import { render, staticRenderFns } from "./movie-table-card.vue?vue&type=template&id=15fe8d88&scoped=true&"
import script from "./movie-table-card.vue?vue&type=script&lang=ts&"
export * from "./movie-table-card.vue?vue&type=script&lang=ts&"
import style0 from "./movie-table-card.vue?vue&type=style&index=0&id=15fe8d88&prod&scoped=true&lang=scss&"
import style1 from "./movie-table-card.vue?vue&type=style&index=1&id=15fe8d88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe8d88",
  null
  
)

export default component.exports